class SiteActionPrint
    extends SiteAction {

    private readonly _action: IActionTypePrint;
    private readonly _card: ISiteCard;

    constructor(card: ISiteCard, action: IActionTypePrint, next: SiteAction | null) {
        super(next);
        this._action = action;
        this._card = card;
    }

    getAction() {
        return this._action as IActionTypePrint;
    }

    async _execute() {
        let print = new SitePrint();
        let path = this._action.path && SiteModel.split(this._action.path) || [];
        this._action.actionLink.model = this._card.Model.get(path);
        
        await print.PrintRequest(this._action.actionLink);

        return true;
    }
}